import { optionsTree, getStroage } from 'utils'
import { Cascader } from 'antd'
import { useEffect, useState } from 'react'
import './CascaderOption.scss'

export const CascaderOption = ({ value, onChange, title, dictData, setIsmodifyTable }) => {
    const [selectedValue, setSelectedValue] = useState()
    const [options, setOptions] = useState()

    useEffect(() => {
        switch (title) {
            case 'personnelType':
                setOptions(optionsTree(dictData[3]?.data.data, 'dictCode'))
                setSelectedValue(value)
                break
            case 'cardType':
                setOptions(optionsTree(dictData[0]?.data.data, 'dictCode'))
                setSelectedValue(value)
                break
            case 'eventType':
                setOptions(optionsTree(dictData[1]?.data.data, 'dictCode'))
                setSelectedValue(value)
                break
            case 'incidentType':
                setOptions(optionsTree(dictData[5]?.data.data, 'dictCode'))
                setSelectedValue(value)
                break
            case 'timeCategory':
                setOptions(optionsTree(dictData, 'dictCode'))
                setSelectedValue(value)
                break
            default:
        }
    }, [])

    useEffect(() => {
        if (!selectedValue) return
        onChange(selectedValue)
    }, [selectedValue])

    // 递归渲染下拉菜单
    const generateOptionsWithKey = (items, parentId = null, index = 0) => {
        return items?.map((item, idx) => {
            const uniqueKey = getStroage('language') === 'zh' ? item?.dictLabel : item?.dictLabelEn

            // 递归处理子选项
            const children = item?.children ? generateOptionsWithKey(item.children, uniqueKey, 0) : null

            return {
                key: uniqueKey, // 添加唯一的key
                label: (
                    <div>
                        <span className='dictColor' style={{ backgroundColor: item?.listClass }}></span>
                        <span>{getStroage('language') === 'zh' ? item?.dictLabel : item?.dictLabelEn}</span>
                    </div>
                ),
                value: item?.dictValue,
                dictColor: item?.listClass,
                children: children, // 替换或添加处理过的子选项
            }
        })
    }

    // 渲染后函数
    const displayRender = (labels, selectedOptions) =>
        labels.map((label, i) => {
            const option = selectedOptions[i]
            if (i === labels.length - 1) {
                return <span key={option?.value}>{option?.key}</span>
            }
            return <span key={option?.value}>{option?.key} / </span>
        })

    return (
        <div>
            <Cascader
                options={generateOptionsWithKey(options)}
                value={selectedValue}
                onChange={value => {
                    setIsmodifyTable(true)
                    setSelectedValue(value)
                }}
                expandTrigger='hover'
                // showSearch={true}
                showSearch={{
                    filter: (inputValue, path) =>
                        path.some(option => option.key.toLowerCase().indexOf(inputValue.toLowerCase()) > -1),
                    render: (inputValue, option) =>
                        option.map((item, index) => {
                            return (
                                <div key={index}>
                                    <span className='dictColor' style={{ backgroundColor: item?.dictColor }}></span>
                                    <span>{item?.key}</span>
                                </div>
                            )
                        }),
                    matchInputWidth: true,
                }}
                allowClear={false}
                displayRender={displayRender}
            />
        </div>
    )
}
